import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';

export function getFormDefinition(vue) {
  return {
    number: {
      type: MDinput,
      defaultValue: null,
      props: {
        maxlength: 2,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    description: {
      type: MDinput,
      defaultValue: null,
      props: {
        maxlength: 255
      }
    },
    planningOrder: {
      type: InputNumber,
      defaultValue: 0,
      props: {
        min: 0,
        step: 1,
        caption: 'yarn.planningOrder'
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
